import React, { FC } from 'react';
import { TypeProduct } from '@/core/generated-types';
import classNames from 'classnames';
import styles from './YotpoReviewStars.module.scss';
import { getShopifyProductId } from '@/utils/getShopifyProductId';

export interface YotpoReviewStarsProps {
  product?: TypeProduct;
  productID?: string;
}

const YotpoReviewStars: FC<YotpoReviewStarsProps> = ({
  product,
  productID,
}) => {
  const appKey = process.env.NEXT_PUBLIC_YOTPO_APP_KEY;

  const shopifyProductId = product ? getShopifyProductId(product) : productID;

  return appKey && shopifyProductId ? (
    <div
      className={classNames('yotpo bottomLine yotpo-small', styles.root)}
      data-appkey={process.env.NEXT_PUBLIC_YOTPO_APP_KEY}
      data-product-id={shopifyProductId}
      data-product-models={shopifyProductId}
      data-testid="yotpo-review-stars"
    />
  ) : null;
};

export default React.memo(YotpoReviewStars);
